import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import { connect } from "react-redux";

// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar.jsx";
import AdminFooter from "../components/Footers/AdminFooter.jsx";
import Sidebar from "../components/Sidebar/Sidebar.jsx";
import logoImg from "../assets/img/brand/argon-react.png";

import routes from "../routes.js";


class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: ''
    }
    this.mainContentRef = React.createRef();
  }
  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (this.mainContentRef.current) {
      this.mainContentRef.current.scrollTop = 0;
    }
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        const Component = prop.component;
        return (
          <Route
            path={prop.path}
            element={<Component />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        path.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  render() {
    let userAuth = JSON.parse(localStorage.getItem('userAuth'));
    if (userAuth === null) {
      return (
        <Navigate to="/auth/login" replace />
      );
    }

    const { location } = this.props;

    return (
      <>
        <Sidebar
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/admin/index",
            imgSrc: logoImg,
            imgAlt: "ServisSoft Portal"
          }}
        />
        <div className="main-content" ref={this.mainContentRef}>
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(location.pathname)}
          />
          <Routes>{this.getRoutes(routes)}</Routes>
          <Container fluid>
            <AdminFooter />
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

// HOC to inject location from useLocation hook
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    return (
      <Component
        {...props}
        location={location}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default connect(
  mapStateToProps,
  {}
)(withRouter(Admin));

